<input type="text" class="bo-input" [(ngModel)]="query" (keyup.enter)="search()"
       [placeholder]="placeholder || 'Cauta cerere dupa numar contract, continut cerere, denumire client sau numar cerere'">
<i class="icon-mobilize-search" (click)="search()"></i>
